export const SET_ENABLE_BACKGROUND_IMAGE_REVISE = 'THEME_OPTIONS/SET_ENABLE_BACKGROUND_IMAGE_REVISE';

export const SET_ENABLE_MOBILE_MENU_REVISE = 'THEME_OPTIONS/SET_ENABLE_MOBILE_MENU_REVISE';
export const SET_ENABLE_MOBILE_MENU_SMALL_REVISE = 'THEME_OPTIONS/SET_ENABLE_MOBILE_MENU_SMALL_REVISE';

export const SET_ENABLE_FIXED_HEADER_REVISE = 'THEME_OPTIONS/SET_ENABLE_FIXED_HEADER_REVISE';
export const SET_ENABLE_HEADER_SHADOW_REVISE = 'THEME_OPTIONS/SET_ENABLE_HEADER_SHADOW_REVISE';
export const SET_ENABLE_SIDEBAR_SHADOW_REVISE = 'THEME_OPTIONS/SET_ENABLE_SIDEBAR_SHADOW_REVISE';
export const SET_ENABLE_FIXED_SIDEBAR_REVISE = 'THEME_OPTIONS/SET_ENABLE_FIXED_SIDEBAR_REVISE';
export const SET_ENABLE_CLOSED_SIDEBAR_REVISE = 'THEME_OPTIONS/SET_ENABLE_CLOSED_SIDEBAR_REVISE';
export const SET_ENABLE_FIXED_FOOTER_REVISE = 'THEME_OPTIONS/SET_ENABLE_FIXED_FOOTER_REVISE';

export const SET_ENABLE_PAGETITLE_ICON_REVISE = 'THEME_OPTIONS/SET_ENABLE_PAGETITLE_ICON_REVISE';
export const SET_ENABLE_PAGETITLE_SUBHEADING_REVISE = 'THEME_OPTIONS/SET_ENABLE_PAGETITLE_SUBHEADING_REVISE';
export const SET_ENABLE_PAGE_TABS_ALT_REVISE = 'THEME_OPTIONS/SET_ENABLE_PAGE_TABS_ALT_REVISE';

export const SET_BACKGROUND_IMAGE_REVISE = 'THEME_OPTIONS/SET_BACKGROUND_IMAGE_REVISE';
export const SET_BACKGROUND_COLOR_REVISE = 'THEME_OPTIONS/SET_BACKGROUND_COLOR_REVISE';
export const SET_COLOR_SCHEME_REVISE = 'THEME_OPTIONS/SET_COLOR_SCHEME_REVISE';
export const SET_BACKGROUND_IMAGE_OPACITY_REVISE = 'THEME_OPTIONS/SET_BACKGROUND_IMAGE_OPACITY_REVISE';

export const SET_HEADER_BACKGROUND_COLOR_REVISE = 'THEME_OPTIONS/SET_HEADER_BACKGROUND_COLOR_REVISE';


export const setEnableBackgroundImageRevise = enableBackgroundImage => ({
    type: SET_ENABLE_BACKGROUND_IMAGE_REVISE,
    enableBackgroundImage
});

export const setEnableFixedHeaderRevise = enableFixedHeader => ({
    type: SET_ENABLE_FIXED_HEADER_REVISE,
    enableFixedHeader
});

export const setEnableHeaderShadowRevise = enableHeaderShadow => ({
    type: SET_ENABLE_HEADER_SHADOW_REVISE,
    enableHeaderShadow
});

export const setEnableSidebarShadowRevise = enableSidebarShadow => ({
    type: SET_ENABLE_SIDEBAR_SHADOW_REVISE,
    enableSidebarShadow
});

export const setEnablePageTitleIconRevise = enablePageTitleIcon => ({
    type: SET_ENABLE_PAGETITLE_ICON_REVISE,
    enablePageTitleIcon
});

export const setEnablePageTitleSubheadingRevise = enablePageTitleSubheading => ({
    type: SET_ENABLE_PAGETITLE_SUBHEADING_REVISE,
    enablePageTitleSubheading
});

export const setEnablePageTabsAltRevise = enablePageTabsAlt => ({
    type: SET_ENABLE_PAGE_TABS_ALT_REVISE,
    enablePageTabsAlt
});

export const setEnableFixedSidebarRevise = enableFixedSidebar => ({
    type: SET_ENABLE_FIXED_SIDEBAR_REVISE,
    enableFixedSidebar
});

export const setEnableClosedSidebarView = enableClosedSidebar => ({
    type: SET_ENABLE_CLOSED_SIDEBAR_REVISE,
    enableClosedSidebar
});

export const setEnableMobileMenuViewRevise = enableMobileMenuView => ({
    type: SET_ENABLE_MOBILE_MENU_REVISE,
    enableMobileMenuView
});

export const setEnableMobileMenuSmallViewRevise = enableMobileMenuSmall => ({
    type: SET_ENABLE_MOBILE_MENU_SMALL_REVISE,
    enableMobileMenuSmall
});

export const setEnableFixedFooterRevise = enableFixedFooter => ({
    type: SET_ENABLE_FIXED_FOOTER_REVISE,
    enableFixedFooter
});

export const setBackgroundColorRevise = backgroundColor => ({
    type: SET_BACKGROUND_COLOR_REVISE,
    backgroundColor
});

export const setHeaderBackgroundColourRevise = headerBackgroundColor => ({
    type: SET_HEADER_BACKGROUND_COLOR_REVISE,
    headerBackgroundColor
});

export const setColorSchemeRevise = colorScheme => ({
    type: SET_COLOR_SCHEME_REVISE,
    colorScheme
});

export const setBackgroundImageOpacityRevise = backgroundImageOpacity => ({
    type: SET_BACKGROUND_IMAGE_OPACITY_REVISE,
    backgroundImageOpacity
});

export const setBackgroundImageRevise = backgroundImage => ({
    type: SET_BACKGROUND_IMAGE_REVISE,
    backgroundImage
});

export default function reducer(state = {
    backgroundColor: (localStorage.getItem('oneviewsiderbarTheme')) ? localStorage.getItem('oneviewsiderbarTheme') : 'bg-royal sidebar-text-light',
    headerBackgroundColor: (localStorage.getItem('oneviewheaderTheme')) ? localStorage.getItem('oneviewheaderTheme') : 'bg-night-sky header-text-light',
    enableMobileMenuSmall: '',
    enableBackgroundImage: true,
    enableClosedSidebar: false,
    enableFixedHeader: true,
    enableHeaderShadow: true,
    enableSidebarShadow: true,
    enableFixedFooter: true,
    enableFixedSidebar: true,
    colorScheme: 'white',
    backgroundImage: undefined,
    backgroundImageOpacity: 'opacity-06',
    enablePageTitleIcon: true,
    enablePageTitleSubheading: true,
    enablePageTabsAlt: false,
}, action) {
    switch (action.type) {
        case SET_ENABLE_BACKGROUND_IMAGE_REVISE:
            return {
                ...state,
                enableBackgroundImage: action.enableBackgroundImage
            };

        case SET_ENABLE_FIXED_HEADER_REVISE:
            return {
                ...state,
                enableFixedHeader: action.enableFixedHeader
            };

        case SET_ENABLE_HEADER_SHADOW_REVISE:
            return {
                ...state,
                enableHeaderShadow: action.enableHeaderShadow
            };

        case SET_ENABLE_SIDEBAR_SHADOW_REVISE:
            return {
                ...state,
                enableSidebarShadow: action.enableSidebarShadow
            };

        case SET_ENABLE_PAGETITLE_ICON_REVISE:
            return {
                ...state,
                enablePageTitleIcon: action.enablePageTitleIcon
            };

        case SET_ENABLE_PAGETITLE_SUBHEADING_REVISE:
            return {
                ...state,
                enablePageTitleSubheading: action.enablePageTitleSubheading
            };

        case SET_ENABLE_PAGE_TABS_ALT_REVISE:
            return {
                ...state,
                enablePageTabsAlt: action.enablePageTabsAlt
            };

        case SET_ENABLE_FIXED_SIDEBAR_REVISE:
            return {
                ...state,
                enableFixedSidebar: action.enableFixedSidebar
            };

        case SET_ENABLE_MOBILE_MENU_REVISE:
            return {
                ...state,
                enableMobileMenuView: action.enableMobileMenuView
            };

        case SET_ENABLE_MOBILE_MENU_SMALL_REVISE:
            return {
                ...state,
                enableMobileMenuSmall: action.enableMobileMenuSmall
            };

        case SET_ENABLE_CLOSED_SIDEBAR_REVISE:
            return {
                ...state,
                enableClosedSidebar: action.enableClosedSidebar
            };

        case SET_ENABLE_FIXED_FOOTER_REVISE:
            return {
                ...state,
                enableFixedFooter: action.enableFixedFooter
            };

        case SET_BACKGROUND_COLOR_REVISE:
            return {
                ...state,
                backgroundColor: action.backgroundColor
            };

        case SET_HEADER_BACKGROUND_COLOR_REVISE:
            return {
                ...state,
                headerBackgroundColor: action.headerBackgroundColor
            };

        case SET_COLOR_SCHEME_REVISE:
            return {
                ...state,
                colorScheme: action.colorScheme
            };

        case SET_BACKGROUND_IMAGE_REVISE:
            return {
                ...state,
                backgroundImage: action.backgroundImage
            };

        case SET_BACKGROUND_IMAGE_OPACITY_REVISE:
            return {
                ...state,
                backgroundImageOpacity: action.backgroundImageOpacity
            };
    }
    return state;
}